import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { solutionBenefits } from '../../data/content';
import { MOCKUP_URL } from '../../data/images';
export function SolutionSection() {
  return <section aria-labelledby="solution-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-158" data-mp="1joehp8h966p5">
      <div className="mx-auto max-w-5xl" data-id="element-159" data-mp="1oiiui8d798y5">
        <SectionHeading id="solution-heading" title={<>
              Tout votre système d’enseignement de la coiffure, <Accent data-id="element-161" data-mp="1ycr87pxkmxc9">au même endroit.</Accent>
            </>} body={<>
              <strong className="font-semibold text-brand-charcoal" data-id="element-162" data-mp="23bkmhkkomsdh">Hair Instructor Ready™ – Édition Française</strong>{' '}
              : un ensemble de 6 volumes professionnels et 5 bonus pratiques conçu pour accompagner la préparation
              et l’organisation des formations en coiffure.
            </>} data-id="element-160" data-mp="1tg0v9bh2chv2" />

        <div className="mt-12 grid items-center gap-10 lg:grid-cols-[1.15fr_1fr]" data-id="element-163" data-mp="m6ppdplejvj">
          <img src={MOCKUP_URL} alt="Le système complet Hair Instructor Ready" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[560px] object-contain" style={{
          filter: 'drop-shadow(0 30px 36px rgba(120, 96, 56, 0.22))'
        }} data-id="element-164" data-mp="3s14bqrc9b6zi" />

          <ul className="space-y-4" role="list" data-id="element-165" data-mp="jj86rwwf8afu">
            {solutionBenefits.map(benefit => <li key={benefit} className="flex items-start gap-4" data-id="element-166" data-mp="ek50ya8ma06t">
                <span className="mt-0.5 flex h-8 w-8 flex-none items-center justify-center rounded-full bg-brand-cta" data-id="element-167" data-mp="9ltr3zibnpol">
                  <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-168" data-mp="4ns97hwmtwep" />
                </span>
                <span className="pt-1 text-[16px] font-medium leading-snug text-brand-charcoal sm:text-[17px]" data-id="element-169" data-mp="2uazm2q9ted0m">
                  {benefit}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-12 max-w-3xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-170" data-mp="1lg5gset9limu">
          Moins de préparation. Plus de clarté. <Accent data-id="element-171" data-mp="1cfqupd8h7zia">Plus de temps pour enseigner.</Accent>
        </p>
      </div>
    </section>;
}